export type FormFieldValue = string | number | boolean | string[] | null;
export type FormValues = Record<string, FormFieldValue>;

export type FormField = {
  name: string;
  label: string;
  type: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  description?: string;
  width?: 'full' | 'half';
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  [key: string]: unknown;
};

export type FormBlock = {
  type: string;
  className?: string;
  [key: string]: unknown;
};

export type FormContent = {
  blocks: FormBlock[];
  containerClassName?: string;
  formClassName?: string;
  errorMessage?: string;
  errorRetryLabel?: string;
  completionMessage?: string;
  completionButtonLabel?: string;
};

export function parseFormContent(content: unknown): FormContent {
  if (
    content &&
    typeof content === 'object' &&
    'blocks' in content &&
    Array.isArray((content as FormContent).blocks)
  ) {
    return content as FormContent;
  }
  return { blocks: [] };
}

export function getAllFields(blocks: FormBlock[]): FormField[] {
  return blocks
    .filter((b) => Array.isArray(b.fields))
    .flatMap((b) => b.fields as FormField[]);
}
